import { z } from 'zod';
import { DEFAULT_PAGE_SIZE, MAX_PAGE_SIZE } from '../constants.js';
/** ISO 8601 date or datetime (with optional offset/Z). */
export const ISO_DATETIME_RE = /^\d{4}-\d{2}-\d{2}(?:[T ]\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?(?:Z|[+-]\d{2}:\d{2})?)?$/;
export const isoDateTime = z.string().regex(ISO_DATETIME_RE, 'Must be an ISO 8601 date or datetime');
/** Entity id: uuid, slug or prefixed id — max 64 chars. */
export const idSchema = z
    .string()
    .min(1)
    .max(64)
    .regex(/^[A-Za-z0-9_.:-]+$/, 'Invalid identifier');
export const currencySchema = z.string().regex(/^[A-Z]{3}$/, 'Must be a 3-letter ISO currency code');
/** Money: 2 decimal places expected — use roundMoney() from shared/pricing when computing. */
export const moneySchema = z.number().finite();
export const weightKgSchema = z.number().finite().positive('Weight must be positive').max(100000);
export const emailSchema = z.string().trim().toLowerCase().email();
/** Loose UK-ish postal/zip validation — international addresses allowed. */
export const postcodeSchema = z.string().trim().min(2).max(16);
export const addressSchema = z.object({
    line1: z.string().trim().min(1).max(200),
    line2: z.string().trim().max(200).nullish(),
    city: z.string().trim().min(1).max(120),
    postcode: postcodeSchema,
    country: z.string().trim().min(2).max(80).default('United Kingdom'),
    contactName: z.string().trim().max(120).nullish(),
    contactPhone: z.string().trim().max(40).nullish(),
    latitude: z.number().finite().min(-90).max(90).nullish(),
    longitude: z.number().finite().min(-180).max(180).nullish(),
});
/* ------------------------------- pagination ------------------------------- */
export const pageQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
    order: z.enum(['asc', 'desc']).default('asc'),
});
export function paginated(item) {
    return z.object({
        items: z.array(item),
        page: z.number().int(),
        pageSize: z.number().int(),
        total: z.number().int(),
        totalPages: z.number().int(),
    });
}
export function paginatedResult(items, total, page, pageSize) {
    return { items, total, page, pageSize, totalPages: pageSize > 0 ? Math.ceil(total / pageSize) : 0 };
}
/** Acknowledgement envelope for write endpoints without payload. */
export const okSchema = z.object({ ok: z.literal(true) });
//# sourceMappingURL=common.js.map